import { Box, Container, Typography, Link, Grid, useTheme, alpha } from '@mui/material';
import longLogo from '../images/long_logo.png';
import greenP100Logo from '../images/greenp100_white.png';

const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        mt: 'auto',
        backgroundColor: 'primary.main',
        color: '#FFFFFF',
        borderTop: '1px solid',
        borderColor: alpha('#FFFFFF', 0.1),
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={3} alignItems="center">
          {/* Left: Long Logo */}
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}>
            <Box
              component="img"
              src={longLogo}
              alt="GREEN P100NEER Logo"
              sx={{
                height: 45,
                width: 'auto',
                filter: 'brightness(0) invert(1)',
              }}
            />
          </Grid>

          {/* Middle: Tagline */}
          <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color={alpha('#FFFFFF', 0.7)}>
              Empowering sustainable business for a greener future.
            </Typography>
          </Grid>

          {/* Right: Green P100 Logo with Copyright */}
          <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box
              component="img"
              src={greenP100Logo}
              alt="GREEN P100NEER Logo"
              sx={{
                height: 65,
                width: 'auto',
                mb: 1.5,
              }}
            />
            <Typography variant="body2" color={alpha('#FFFFFF', 0.9)} align="center">
              © 2025{' '}
              <Link 
                sx={{ 
                  color: alpha('#FFFFFF', 0.9),
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': {
                    color: theme.palette.secondary.main,
                    textDecoration: 'underline',
                  }
                }} 
                href="https://www.ocpower.org/energy-programs/green-p100neer-program/" 
                target="_blank"
                rel="noopener noreferrer"
              >
                GREEN P<Box component="span" sx={{ fontWeight: 800, display: 'inline' }}>100</Box>NEER Initiative
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer; 